import React from "react";
import { NavLink } from "react-router-dom";
import {
  AppId,
  NAV_SECTIONS,
  NavItem,
  canAccessScreen,
  getScreen,
  screenUrl,
} from "../config/apps";
import { useAuth } from "../providers/AuthProvider";

/**
 * Renders NAV_SECTIONS. Screens of the current app are client-side links; the
 * rest live on other subdomains, so they link out.
 */
export const SideNav: React.FC<{ current: AppId }> = ({ current }) => {
  const { roles } = useAuth();

  const renderItem = (item: NavItem, sub: boolean) => {
    const screen = getScreen(item.screen);
    const className = `side-nav-link${sub ? " side-nav-sublink" : ""}`;
    const label = item.label ?? screen.label;
    return screen.app === current ? (
      <NavLink
        key={screen.id}
        exact
        to={screen.path}
        className={className}
        activeClassName="active"
      >
        {label}
      </NavLink>
    ) : (
      <a key={screen.id} href={screenUrl(screen.id)} className={className}>
        {label}
      </a>
    );
  };

  return (
    <nav className="side-nav">
      {NAV_SECTIONS.map((section) => {
        const items = section.items.filter((item) =>
          canAccessScreen(roles, getScreen(item.screen)),
        );
        if (items.length === 0) return null;
        if (!section.title) {
          return items.map((item) => renderItem(item, false));
        }
        return (
          <div key={section.title} className="side-nav-group">
            <span className="side-nav-heading">{section.title}</span>
            {items.map((item) => renderItem(item, true))}
          </div>
        );
      })}
    </nav>
  );
};
